import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";


const AuthCallBack = () => {
    const { refreshUser } = useAuth();
    const navigate = useNavigate();
    const handledRef = React.useRef(false);

    useEffect(() => {
        const handleRedirect = async () => {
            if (handledRef.current) return;
            handledRef.current = true;
            try {
                await refreshUser();
                const redirectTo = sessionStorage.getItem("postLoginRedirect") || "/dashboard";
                sessionStorage.removeItem("postLoginRedirect");
                navigate(redirectTo, { replace: true });
            } catch {
                navigate('/');
            }
        };

        handleRedirect();
    }, [navigate, refreshUser]);

}

export default AuthCallBack;